// fieldValueResolver.js

// Shared schema field lookup across data_{type} containers and root node fields.
export const resolveSchemaFieldValue = ({
  item,
  fieldDef,
  typeKey,
  dataSection,
}) => {
  if (!item || !fieldDef) return undefined;

  const fieldKey = fieldDef?.name || fieldDef?.key || '';
  if (!fieldKey) return undefined;

  const nodeTypeSection = typeKey
    ? `data_${String(typeKey).toLowerCase()}`
    : null;
  const sourceKey = String(fieldDef?.source || '').toLowerCase();
  const preferredSection = sourceKey ? `data_${sourceKey}` : null;
  const sectionsToTry = [];

  if (nodeTypeSection) sectionsToTry.push(nodeTypeSection);
  if (preferredSection && preferredSection !== nodeTypeSection) {
    sectionsToTry.push(preferredSection);
  }
  if (dataSection) sectionsToTry.push(dataSection);

  sectionsToTry.push(
    ...Object.keys(item)
      .filter((key) => key.startsWith('data_'))
  );

  const seen = new Set();
  for (const sectionKey of sectionsToTry) {
    if (!sectionKey || seen.has(sectionKey)) continue;
    seen.add(sectionKey);
    const container = item?.[sectionKey];
    if (container && typeof container === 'object' && container[fieldKey] !== undefined) {
      return container[fieldKey];
    }
  }

  if (Object.prototype.hasOwnProperty.call(item, fieldKey)) {
    return item[fieldKey];
  }

  return undefined;
};
